import { Injectable } from '@angular/core';

import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { IBetslip } from '../../../../../bet-generation/models';
import { GroupWithUncombinableLegsError } from '../../../../errors/general/group-pick-error';
import { ComboBetValidationContext } from '../../../../models/models';
import { IComboBetBetslipValidator } from '../validators';

@Injectable()
export class GroupPickComboBetWithUncombinableLegsValidator implements IComboBetBetslipValidator<GroupWithUncombinableLegsError> {
    validate(_: IBetslip, context: ComboBetValidationContext): GroupWithUncombinableLegsError[] {
        const invalidPicks = context.typeContext.selectedPicks
            .filter<BaseBetslipGroupPick>(BaseBetslipGroupPick.isPick)
            .filter((p) => p.groupHasUncombinableLeg());

        const noncombinableLegs = invalidPicks.flatMap((p) =>
            p
                .getLegs()
                .filter((l) => p.legIsNoncombinable(l.id))
                .map((l) => l.id),
        );

        const invalidPickIds = invalidPicks.map((p) => p.id);

        return noncombinableLegs.length > 0 ? [new GroupWithUncombinableLegsError(noncombinableLegs, invalidPickIds)] : [];
    }
}
